
import { useSnackbar } from 'notistack';

import { useRecoilValue } from 'recoil';

import useAxios from 'library/axios'; 
import { useState } from 'react';
import {IClassroom, IClassroomSearch } from "../models/Classroom";
import { useTranslation  } from 'react-i18next';
import { ITextFilterElement } from 'components/ui/BasicTextFilterForm';
import { IResult } from 'library/interface';
import { HeadCell, RowCheckedMode } from 'components/ui/EnhancedTable';


import { currentUserSessionAtom } from 'library/store';


const _ = () => {

    const axios = useAxios(); 

    //const {requestTypeBusinessApps} = useRecoilValue(currentUserSessionAtom);    

    const createClassroom = async (classroom: IClassroom)  =>       
        await (await axios.post('/api/setup/classroom/create', classroom)).data;       
        
    const updateClassroom = async (classroom: IClassroom)  =>       
        await (await axios.post('/api/setup/classroom/update', classroom)).data; 
    
    const getClassroom = async (id  : number )  => {
      const {data} = (await axios.get(`/api/setup/classroom/get-classroom/${id}`));
      return await data;
    }
   

    const getClassrooms = async (criteria: IClassroomSearch) : Promise<IClassroom[]> => {

      const { name, localisation} = criteria;

      const {data} = (await axios.get(`/api/setup/classroom/get-classrooms?name=${name}&localisation=${localisation}`));
      return await data;
    }
    
      
    return {    
      createClassroom,
      updateClassroom,
      getClassroom,
      getClassrooms
      
    } 
}

export default _;

export interface IFilterClassroomOption {
  rowCheckedMode: RowCheckedMode,
  stateSelected?: [string[], React.Dispatch<React.SetStateAction<string[]>>],
  stateFiltered?: [IClassroom[], React.Dispatch<React.SetStateAction<IClassroom[]>>],
}

const defaultFilterClassroomOption: IFilterClassroomOption = {
  rowCheckedMode: 'single'
  //stateSelected: navigate
}


export const useBasicFilterClassroom = (  onRowDoubleClick: (event: React.MouseEvent<unknown>, row: IClassroom) => void,
                                            filterOption?: IFilterClassroomOption  ) => {

  const { getClassrooms } = _();

  const { t, i18n } = useTranslation();   
  const {rowCheckedMode, stateSelected, stateFiltered} = filterOption || defaultFilterClassroomOption;



  const [headClassroomCells, setHeadClassroomCells]  = useState<HeadCell<IClassroom>[]>([
    {id:'id', label : t('Id'),  display: true, type: 'numeric', },    
    {id:'name', label : t('Name'),  display: true, type: 'string', },
    {id:'isActive', label : t('Active ?'),  display: true, type: 'boolean', },
    {id:'localisation', label : t('Localisation'),  display: true, type: 'string', },
    {id:'capacity', label : t('Capacity'),  display: true, type: 'numeric', },
    

  ]); 
  const [filterElements,] = useState<ITextFilterElement[]>( [         
      
      {name: 'name', text: t('Name'), value: ''},
      {name: 'localisation', text: t('Localisation'), value: ''},
      
    ]);    

  const [filteredClassrooms, ] = useState<IClassroom[]>([]); 

  const onFilterButtonClick = async (filterElements: ITextFilterElement[]) : Promise<IClassroom[]> => {
    
    
    const name = filterElements.find( elt => elt.name === 'name')?.value || '';
    const localisation = filterElements.find( elt => elt.name === 'localisation')?.value || '';       

    const arr = await getClassrooms( { name,localisation} );
   
    return arr;
  }

  const objKey: keyof IClassroom = 'id';

  return {
    title: t('Classroom'), headCells: headClassroomCells, objKey,
    filterElements, rows: filteredClassrooms, 
    onFilterButtonClick, onRowDoubleClick, rowCheckedMode, stateSelected, stateFiltered
  }
}
